// Function to push to the datalayer
export const ga = async (e: DataLayerEvents): Promise<void> => {
  window.dataLayer = window.dataLayer || [];
  console.log(`Pushing Data Layer Event '${e.event}'`, e);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const parsedData = e as Record<string, any>;

  Object.keys(parsedData).forEach(key => {
    if (parsedData[key] === '' || parsedData[key] === undefined) {
      delete parsedData[key];
    }
  });

  if (window && window.dataLayer) {
    window.dataLayer.push({
      event: e.event,
      ...parsedData,
    });
  }
};

type DataLayerEvent = 'packout_add_to_build' | 'packout_remove_from_build' | 'packout_export_build' | 'packout_download';

export type DataLayerEvents = PackoutAddToBuildEvent | PackoutRemoveFromBuildEvent | PackoutExportBuildEvent;

interface BaseDataLayerEvent {
  event: DataLayerEvent;
  packout_builder_type: 'stack_builder' | 'wall_storage_builder';
}

interface PackoutAddToBuildEvent extends BaseDataLayerEvent {
  event: 'packout_add_to_build';
  packout_category: string;
  article_number: string;
}

interface PackoutRemoveFromBuildEvent extends BaseDataLayerEvent {
  event: 'packout_remove_from_build';
  packout_category: string;
  article_number: string;
}

interface PackoutExportBuildEvent extends BaseDataLayerEvent {
  event: 'packout_export_build';
}
